import convertToArray from './convertToArray';

class ExpandArticle {
  init() {
    this.doc = document;
    this.contentAttr = 'data-expand-content';
    this.content = convertToArray(this.doc.querySelectorAll(`[${this.contentAttr}]`));
    this.contentLen = this.content.length;
    this.btnActiveClass = 'is_active';
    this.contentActiveClass = 'is_active';
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }
  start() {
    this.btnAttr = 'data-expand-btn';
    this.btn = convertToArray(document.querySelectorAll(`[${this.btnAttr}]`));
    this.btnLen = this.btn.length;
    if (!this.btnLen) return;
    this.init();
    for (let bi = 0; bi < this.btnLen; bi += 1) {
      this.btn[bi].addEventListener('click', this.show);
    }
  }
  show(e) {
    e.preventDefault();
    const current = e.currentTarget;
    const attrVal = current.getAttribute(this.btnAttr);
    current.classList.add(this.btnActiveClass);
    for (let ci = 0; ci < this.contentLen; ci += 1) {
      const target = this.content[ci];
      if (target.getAttribute(this.contentAttr) === attrVal) {
        target.classList.add(this.contentActiveClass);
      }
    }
    current.removeEventListener('click', this.show);
    current.addEventListener('click', this.hide);
  }
  hide(e) {
    e.preventDefault();
    const current = e.currentTarget;
    const attrVal = current.getAttribute(this.btnAttr);
    current.classList.remove(this.btnActiveClass);
    for (let ci = 0; ci < this.contentLen; ci += 1) {
      const target = this.content[ci];
      if (target.getAttribute(this.contentAttr) === attrVal) {
        target.classList.remove(this.contentActiveClass);
      }
    }
    current.removeEventListener('click', this.hide);
    current.addEventListener('click', this.show);
  }
}
export default ExpandArticle;



// WEBPACK FOOTER //
// ./src/js/module/ExpandArticle.js